export const TAB = {
    Reports: "reports",
    Items: "items",
} as const;

export type ActiveTab = (typeof TAB)[keyof typeof TAB];

export const SUB_TAB = {
    Preview: "preview",
    Review: "review",
    Completed: "completed",
} as const;

export type ActiveSubTab = (typeof SUB_TAB)[keyof typeof SUB_TAB];

export const DETAIL_TAB = {
    Details: "details",
    History: "history",
    Communications: "communications",
} as const;

export type DetailTab = (typeof DETAIL_TAB)[keyof typeof DETAIL_TAB];

export const VIEW = {
    Dashboard: "dashboard",
    Approval: "approval",
    Users: "users",
    Groups: "groups",
    Categories: "categories",
    PolicyExceptions: "policy-exceptions",
    PolicyMileage: "policy-mileage",
    PolicyCurrency: "policy-currency",
    PolicyHotel: "policy-hotel",
    PolicyReceipt: "policy-receipt",
    Permissions: "permissions",
} as const;

export type ActiveView = (typeof VIEW)[keyof typeof VIEW];

const POLICY_VIEW_SET = new Set<ActiveView>([VIEW.PolicyExceptions, VIEW.PolicyMileage, VIEW.PolicyCurrency, VIEW.PolicyHotel, VIEW.PolicyReceipt]);

export function isPolicyView(view: ActiveView): boolean {
    return POLICY_VIEW_SET.has(view);
}
